import React from 'react'

const RowGroup = ({ children, classes = '' }) => {
  return (
    <div className={`gll-market-group__row ${classes || ''}`}>{children}</div>
  )
}

export default React.memo(RowGroup)
